<template>
    <div class="header-container">
        <div class="header">
            <div class="brand">
                <a href="/">
                    <h1 class="title">
                        aephin
                    </h1>
                </a>
                <p class="subtitle">
                    Search Interface for Environmental Site Assessment Repository (ESAR)
                </p>
            </div>
            <div class="nav">
                <ul class="links">
                    <li class="link">
                        <a href="../index.html">Home</a>
                    </li>
                    <li class="link">
                        <a href="../navPages/about.htm">About</a>
                    </li>
                    <li class="link">
                        <a href="../navPages/contact.htm">Contact</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="subheader">
            <p class="blurb">
                This Environmental Site Assessment Repository (ESAR) search interface webpage on
                AEPHIN provides
                more features for searching and navigating the public records available at
                <a
                    href="https://esar.alberta.ca/"
                    target="_blank"
                >https://esar.alberta.ca/</a>. Any disclaimers or
                restrictions from the original ESAR website also apply to this webpage. This AEPHIN
                webpage was updated every
                6-12 months; please note that ESAR is now replaced by Long Term Management on
                Environmental Records Viewer:
                <a
                    href="https://geospatial.alberta.ca/erv/"
                    target="_blank"
                >https://geospatial.alberta.ca/erv/</a> and this visualization is for historical records only.
            </p>

            <div class="date-and-tutorial">
                <div class="date">
                    Last updated on {{ dateGenerated }}
                </div>
                <div class="tutorial-link">
                    <a
                        href="https://aephin.dha.io/pdfs/esar/health-aephin-ESAR-how-to-use-this-tool.pdf"
                        target="_blank"
                    >How to use this tool (PDF) <img
                        :src="Question"
                        alt=""
                    ></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { DateTime } from 'luxon';

import { created_date as dateGenerated } from '@/data/created_date.json';
import Question from '@/assets/img/question-icon.svg';

export default defineComponent({
    name: 'Header',
    components: {},
    setup() {
        return {
            dateGenerated: DateTime.fromISO(dateGenerated)
                .toLocaleString(DateTime.DATE_MED),
            Question
        };
    }
});
</script>

<style lang="postcss" scoped>
.header-container {
    .header {
        @apply w-full flex;

        .brand {
            @apply w-1/2;

            .title {
                @apply text-header-title text-5xl uppercase leading-none font-bold;
            }

            .subtitle {
                @apply text-xl font-light leading-none;
            }
        }

        .nav {
            @apply w-1/2 flex justify-between items-end flex-col;

            .links {
                @apply flex;

                .link {
                    @apply mx-2 cursor-pointer text-header-link text-base font-normal;

                    &:last-of-type {
                        @apply mr-0;
                    }
                }
            }
        }
    }

    .subheader {
        @apply grid mt-3;
        grid-template-columns: 2fr 1fr;

        .blurb {
            @apply text-sm font-light;

            a {
                @apply text-link;
            }
        }

        .date-and-tutorial {
            @apply flex flex-col items-end h-full justify-around;

            .date {
                @apply text-xs text-gray-600;
            }

            .tutorial-link {
                @apply text-link justify-self-end self-end;
                font-weight: 500;

                img {
                    @apply inline ml-1;
                }
            }
        }
    }
}
</style>
